import { PREPROD_PREVIEW_EVENTS, PREPROD_PREVIEW_ACTIONS } from "./types";
export var initiatePreproductBoardEvent = function(iframeRef, markAsVisited) {
    var ref;
    if (iframeRef === null || iframeRef === void 0 ? void 0 : (ref = iframeRef.current) === null || ref === void 0 ? void 0 : ref.contentWindow) {
        iframeRef.current.contentWindow.postMessage({
            type: PREPROD_PREVIEW_EVENTS.LITE_CREATE_BOARD,
            visited: markAsVisited
        }, "*");
    }
};
export var fitContentEvent = function(iframeRef) {
    var ref;
    if (iframeRef === null || iframeRef === void 0 ? void 0 : (ref = iframeRef.current) === null || ref === void 0 ? void 0 : ref.contentWindow) {
        iframeRef.current.contentWindow.postMessage({
            type: PREPROD_PREVIEW_EVENTS.LITE_FIT_CONTENT
        }, "*");
    }
};
export var fullscreenStatusEvent = function(iframeRef, isFullscreen) {
    var ref;
    if (iframeRef === null || iframeRef === void 0 ? void 0 : (ref = iframeRef.current) === null || ref === void 0 ? void 0 : ref.contentWindow) {
        iframeRef.current.contentWindow.postMessage({
            type: PREPROD_PREVIEW_EVENTS.LITE_FULLSCREEN_STATUS,
            payload: isFullscreen
        }, "*");
    }
};
export var initiatePreproductBoardAction = function(dispatch) {
    dispatch({
        type: PREPROD_PREVIEW_ACTIONS.SET_IS_IFRAME_VISIBLE,
        payload: true
    });
    dispatch({
        type: PREPROD_PREVIEW_ACTIONS.SET_BOARD_CONTAINER_DISPLAY_MODE,
        payload: "modal"
    });
};
